import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Button from 'Components/UI/Button';
import Typography from 'Components/UI/Typography';
import {
  getMaxWidthContainerParent,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import HeaderBar from 'Components/ComponentLibrary/Molecules/HeaderBar';
import HamburgerMenuWithSiteNavigation from 'Components/ComponentLibrary/Molecules/HamburgerMenuWithSiteNavigation';
import useUserContext from 'Context/UserContext';
import { FDContentContainer } from '@facet-wealth/design';

const useStyles = buildUseStyles('ManagedAccountPageHeader', (theme) => ({
  root: {
    ...getMaxWidthContainerParent({ theme }),
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: theme.heights.clientNavigationHeight,
  },
  title: {
    textTransform: 'uppercase',
  },
  leftIcon: {
    color: theme.palette.facet.mediumDarkGray,
  },
  appBar: {
    position: 'static',
    marginLeft: 'auto',
  },
}));

export default function ManagedAccountPageHeader({ title, onLeftAction }) {
  const isMobile = useMobileLayout();
  const { isAgent } = useUserContext();
  const classes = useStyles({ isMobile, isAgent });

  if (isMobile) {
    if (isAgent) return null;
    return <>
      <HeaderBar
        title={title}
        left={<HamburgerMenuWithSiteNavigation />}
        TitleProps={{
          test: 'managed-account-screen-header-name',
        }}
      />
    </>;
  }

  return <>
    <Box className={classes.root}>
      <FDContentContainer maxWidth="xl">
        <Box className={classes.content}>
          {onLeftAction ? <>
            <Button onClick={onLeftAction} padding="dense">
              <ArrowBackIosIcon className={classes.leftIcon} fontSize="small" />
              {title ? <>
                <Typography color="mediumDarkGray" className={classes.title} variant="h6" weight="bold" test="managed-account-screen-header-name">
                  {title}
                </Typography>
              </> : null}
            </Button>
          </> : null}
        </Box>
      </FDContentContainer>
    </Box>
  </>;
}
